import eventMessage from 'src/components/event-message';
import { HB_EVENT_NAME } from 'src/constant';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
// import { onCLS, onFID, onLCP } from 'web-vitals';
// import { onCLS } from 'lib/web-vitals/dist/modules/onCLS';
// import { onFID } from 'lib/web-vitals/dist/modules/onFID';
import { onLCP } from 'lib/web-vitals/dist/modules/onLCP';
// import { onINP } from 'lib/web-vitals/dist/modules/onINP';

export default () => {
  // onCLS((metric: { name: string, value: number }) => {
  //   eventMessage.publish<HBEventData<HBPerf>>({
  //     time: Date.now(),
  //     type: EVENT_MSG_TYPE.OTHER,
  //     data: {
  //       en: HB_EVENT_NAME.PERF,
  //       pkey: metric.name,
  //       pval: metric.value,
  //     },
  //   });
  // });
  // onFID((metric) => {
  //   eventMessage.publish<HBEventData<HBPerf>>({
  //     time: Date.now(),
  //     type: EVENT_MSG_TYPE.OTHER,
  //     data: {
  //       en: HB_EVENT_NAME.PERF,
  //       pkey: metric.name,
  //       pval: metric.value,
  //     },
  //   });
  // });
  // onINP((metric) => {
  //   eventMessage.publish<HBEventData<HBPerf>>({
  //     time: Date.now(),
  //     type: EVENT_MSG_TYPE.OTHER,
  //     data: {
  //       en: HB_EVENT_NAME.PERF,
  //       pkey: metric.name,
  //       pval: metric.value,
  //     },
  //   });
  // });
  onLCP((metric) => {
    eventMessage.publish<HBEventData<HBPerf>>({
      time: Date.now(),
      type: EVENT_MSG_TYPE.OTHER,
      data: {
        en: HB_EVENT_NAME.PERF,
        pkey: metric.name,
        pval: metric.value,
      },
    });
  });
}
